import Vue from 'vue'
import Router from 'vue-router'

import NotFound from './views/NotFound.vue'
import Home from './views/Home.vue'
import Monitor from './views/Monitor.vue'
import Acquisitions from './views/Acquisitions.vue'
import Consumptions from './views/Consumptions.vue'
import System from './views/System.vue'
import Report from './views/Report.vue'
import Login from './views/auth/Login.vue'
import Logout from './views/auth/Logout.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  
  linkActiveClass: 'active',

  // base: process.env.BACKEND_BASE_PATH,

  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
      }
    },  
    
    {
      path: '/monitor',
      name: 'monitor',
      component: Monitor,
      meta: {
        requiresAuth: true,
      }
    },  

    {
      path: '/acquisizioni',
      name: 'acquisitions',
      component: Acquisitions,
      // meta: {
      //   requiresAuth: false,
      // }
    },  

    {
      path: '/consumi',
      name: 'consumptions',
      component: Consumptions,
      meta: {
        requiresAuth: true,
      }
    },  

    {
      path: '/sistema',
      name: 'system',
      component: System,
      meta: {
        requiresAuth: true,
      }
    },  

    {
      path: '/report',
      name: 'report',
      component: Report,
      meta: {
        requiresAuth: true,
      }
    },  

    {
      path: '/login',
      name: 'login',
      component: Login,
      props: true,
      meta: {
        requiresVisitor: true,
      }
    },

    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: {
        requiresAuth: true,
      }
    },

    {
      path: '*',
      component: NotFound
    },
    
  ]
})
